import styled from 'styled-components';
import { Card } from 'antd';

export const ResetPasswordContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  padding: 20px;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(circle at 20% 50%, rgba(24, 144, 255, 0.03) 0%, transparent 50%),
      radial-gradient(circle at 80% 80%, rgba(82, 196, 26, 0.03) 0%, transparent 50%);
    pointer-events: none;
  }
`;

export const StyledCard = styled(Card)`
  width: 100%;
  max-width: 420px;
  box-shadow: 
    0 1px 3px rgba(0, 0, 0, 0.08),
    0 4px 12px rgba(0, 0, 0, 0.04);
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  position: relative;
  z-index: 1;
  background: #ffffff;

  .ant-card-body {
    padding: 40px;
  }
`;

